import React from "react";
import { observer } from "mobx-react";

const WhatsAppProfileCard = observer(props => {
  const {
    firstName,
    lastName,
    phoneNumber = "",
    accountId = "",
    profilePictureUrl = "",
    showTitle = false
  } = props || {};

  const safe = (v) => {
    if (v == null || v === "" || String(v).toLowerCase() === "null" || String(v).toLowerCase() === "undefined") return "";
    return String(v).trim();
  };
  const first = safe(firstName);
  const last = safe(lastName);
  const phone = safe(phoneNumber);
  const hasName = !!(first || last);
  const fullName = hasName ? [first, last].filter(Boolean).join(" ") : "";
  const displayName = fullName || phone || "WhatsApp Account";
  const isGenericLabel = displayName === "WhatsApp Account";
  const shortId = accountId && accountId.length >= 6 ? `···${accountId.slice(-6)}` : "";

  return (
    <div className="profileInformation">
      <div className="leftLayout">
        {profilePictureUrl ? (
          <img className="imgUrl" src={profilePictureUrl} alt={displayName} />
        ) : (
          <div
            className="imgUrl"
            style={{
              background: "#25D366",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "24px",
              borderRadius: "50%",
              width: "48px",
              height: "48px"
            }}
          >
            <i className="material-icons" style={{ fontSize: "28px" }}>
              chat
            </i>
          </div>
        )}
      </div>
      <div className="rightLayout">
        <div className="flexRow">
          <span className="fullName">
            {isGenericLabel || /^[\d+]/.test(displayName) ? displayName : displayName.toLowerCase()}
          </span>
        </div>
        {showTitle && phone && (
          <span className="jobDetails">{phone}</span>
        )}
        {!showTitle && phone && (
          <div className="publicUrl">{phone}</div>
        )}
        {!showTitle && isGenericLabel && shortId && (
          <div className="publicUrl" style={{ fontSize: "12px", color: "#888" }}>ID: {shortId}</div>
        )}
      </div>
    </div>
  );
});

export { WhatsAppProfileCard };
export default WhatsAppProfileCard;
